var arrayParser = function (options, nextParser) {
    if (options === void 0) { options = {}; }
    var _a = options.separator, separator = _a === void 0 ? '+' : _a, _b = options.fallback, fallback = _b === void 0 ? [] : _b;
    return {
        parse: function (data) {
            var parsed = data ? decodeURIComponent(data).split(separator) : fallback;
            if (parsed.length == 1) {
                return nextParser ? nextParser.parse(parsed[0]) : parsed[0];
            }
            return nextParser ? parsed.map(nextParser.parse) : parsed;
        },
        stringify: function (data, options) {
            if (data === void 0) { data = fallback; }
            if (options === void 0) { options = { encode: true }; }
            if (typeof data === 'string')
                return data;
            var toStringify = nextParser
                ? data.map(function (item) { return decodeURIComponent(nextParser.stringify(item)); })
                : data;
            /**
             * sounds like the code never enter here, but in tests on `examples/rave-basics`
             * we need todo this when combine some parsers together, we just need understand
             * what combination is to reproduce in your unit tests.
             */
            if (!Array.isArray(toStringify)) {
                if (options.encode) {
                    return encodeURIComponent(Array(toStringify).filter(Boolean).join(separator));
                }
                return Array(toStringify).filter(Boolean).join(separator);
            }
            if (options.encode) {
                return encodeURIComponent(toStringify.filter(Boolean).join(separator));
            }
            return toStringify.filter(Boolean).join(separator);
        },
    };
};
export default arrayParser;
//# sourceMappingURL=array-parser.js.map